(() => {
  if (window.JorgsholmLiveSale) {
    window.JorgsholmLiveSale.init(document);
    return;
  }

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const pad = (value) => String(value).padStart(2, '0');
  const clamp = (value) => Math.min(1, Math.max(0, value));

  const initCountdowns = (scope) => {
    scope.querySelectorAll('[data-jxls-countdown]').forEach((countdown) => {
      if (countdown.dataset.jxlsReady === 'true') return;
      countdown.dataset.jxlsReady = 'true';

      const target = Date.parse(countdown.dataset.target || '');
      const days = countdown.querySelector('[data-jxls-days]');
      const hours = countdown.querySelector('[data-jxls-hours]');
      const minutes = countdown.querySelector('[data-jxls-minutes]');
      const seconds = countdown.querySelector('[data-jxls-seconds]');

      const update = () => {
        const difference = Number.isFinite(target) ? Math.max(0, target - Date.now()) : 0;
        if (days) days.textContent = pad(Math.floor(difference / 86400000));
        if (hours) hours.textContent = pad(Math.floor((difference % 86400000) / 3600000));
        if (minutes) minutes.textContent = pad(Math.floor((difference % 3600000) / 60000));
        if (seconds) seconds.textContent = pad(Math.floor((difference % 60000) / 1000));
      };

      update();
      countdown.jxlsTimer = window.setInterval(update, 1000);
    });
  };

  const initReveal = (scope) => {
    const elements = scope.querySelectorAll('[data-jxls-reveal]');
    if (reducedMotion.matches || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12 });

    elements.forEach((element) => {
      if (element.dataset.jxlsRevealReady === 'true') return;
      element.dataset.jxlsRevealReady = 'true';
      if (element.getBoundingClientRect().top <= window.innerHeight * 0.84) return;

      element.style.opacity = '0';
      element.style.transform = 'translateY(38px)';
      element.style.transition = 'opacity 1.05s cubic-bezier(.22,.61,.21,1), transform 1.05s cubic-bezier(.22,.61,.21,1)';
      element.style.transitionDelay = `${element.dataset.jxlsRevealDelay || 0}ms`;
      observer.observe(element);
    });
  };

  const initScrollButtons = (scope) => {
    scope.querySelectorAll('[data-jxls-scroll-to]').forEach((button) => {
      if (button.dataset.jxlsScrollReady === 'true') return;
      button.dataset.jxlsScrollReady = 'true';
      button.addEventListener('click', () => {
        const target = document.getElementById(button.dataset.jxlsScrollTo || '');
        if (!target) return;
        const top = target.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      });
    });
  };

  const initFaqs = (scope) => {
    scope.querySelectorAll('.jxls-faq__item').forEach((item) => {
      if (item.dataset.jxlsFaqReady === 'true') return;
      const summary = item.querySelector('.jxls-faq__summary');
      if (!summary) return;
      item.dataset.jxlsFaqReady = 'true';

      summary.addEventListener('click', (event) => {
        event.preventDefault();

        if (reducedMotion.matches) {
          item.open = !item.open;
          return;
        }

        if (!item.open) {
          item.classList.remove('is-closing');
          item.open = true;
          return;
        }

        item.classList.add('is-closing');
        window.setTimeout(() => {
          item.open = false;
          item.classList.remove('is-closing');
        }, 420);
      });
    });
  };

  let ticking = false;
  const updateMotion = () => {
    ticking = false;
    const scrollY = window.scrollY;
    const viewportHeight = window.innerHeight;

    document.querySelectorAll('[data-jxls-hero]').forEach((hero) => {
      const image = hero.querySelector('[data-jxls-hero-image], .jxls-hero__image');
      const content = hero.querySelector('[data-jxls-hero-content]');
      if (scrollY >= viewportHeight * 1.3) return;

      if (image && !reducedMotion.matches) {
        image.style.transform = `translate3d(0, ${(scrollY * 0.2).toFixed(1)}px, 0) scale(1.04)`;
      }
      if (content) {
        const progress = clamp(scrollY / (viewportHeight * 0.7));
        content.style.opacity = String(1 - progress * 0.9);
        content.style.transform = `translateY(${(progress * -20).toFixed(1)}px)`;
      }
    });

    if (!reducedMotion.matches) {
      document.querySelectorAll('[data-jxls-parallax]').forEach((element) => {
        const rect = element.getBoundingClientRect();
        if (rect.bottom < -200 || rect.top > viewportHeight + 200) return;
        const speed = Number.parseFloat(element.dataset.jxlsParallax || '0');
        const scale = element.dataset.jxlsScale;
        const offset = (rect.top + rect.height / 2 - viewportHeight / 2) * speed;
        element.style.transform = `translate3d(0, ${offset.toFixed(1)}px, 0)${scale ? ` scale(${scale})` : ''}`;
      });
    }

    document.querySelectorAll('[data-jxls-sticky]').forEach((sticky) => {
      const target = document.getElementById(sticky.dataset.target || '');
      const formSections = document.querySelectorAll('[data-jxls-form-section]');
      const footer = document.querySelector('footer');
      let formInView = false;

      formSections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        if (rect.top < viewportHeight * 0.9 && rect.bottom > viewportHeight * 0.1) formInView = true;
      });

      const targetInView = target
        ? target.getBoundingClientRect().top < viewportHeight * 0.9 && target.getBoundingClientRect().bottom > viewportHeight * 0.1
        : false;
      const footerInView = footer ? footer.getBoundingClientRect().top < viewportHeight * 0.92 : false;
      const hidden = scrollY < viewportHeight * 0.7 || formInView || targetInView || footerInView;
      sticky.classList.toggle('is-visible', !hidden);
    });
  };

  const requestMotionUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateMotion);
  };

  const init = (scope = document) => {
    document.documentElement.classList.add('jxls-page');
    initCountdowns(scope);
    initReveal(scope);
    initScrollButtons(scope);
    initFaqs(scope);
    requestMotionUpdate();
  };

  window.JorgsholmLiveSale = { init };
  window.addEventListener('scroll', requestMotionUpdate, { passive: true });
  window.addEventListener('resize', requestMotionUpdate, { passive: true });
  document.addEventListener('shopify:section:load', (event) => init(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
})();
